module.exports = __webpack_public_path__ + "img/东风商用车-1.ae25b331.png";